import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { APP_CONFIG } from '@constants';

const useGiftCard = ({ checkData }) => {
  const navigate = useNavigate();

  const open = useCallback(() => {
    navigate(`${APP_CONFIG.BASE_URL}/giftcard/${checkData?.id}?type=more`, {
      replace: true,
    });
  }, [navigate, checkData?.id]);

  return { open };
};

export default useGiftCard;
